import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import moment from "moment"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as dealApis from "../utilities/apis/deal"
import { url } from "../utilities/enumerations/constants"

const Deal = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const userState = useSelector((state) => state.user)
  const { slug } = useParams()
  const [deal, setDeal] = useState(null)

  const handleCart = async () => {
    dispatch(cartSlice.addToCart(deal))
  }

  const handleDecrement = async () => {
    dispatch(cartSlice.handleDecrement(deal.slug))
  }

  const handleIncrement = async () => {
    if (cartState.productsById[deal.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleIncrement(deal.slug))
  }

  const getDeal = async () => {
    try {
      const response = await dealApis.getHomeDeal(slug)
      if (!response.status) throw new Error(response.message)

      setDeal(response.deal)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (slug) getDeal()
  }, [slug])

  if (!deal) return

  let src = "/upload-white.png"
  if (deal.thumbnail) src = deal.thumbnail
  // if (deal.thumbnail_url) src = deal.thumbnail_url.replace("public", url)

  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <div className="container py-4">
        <div className="row gy-3 gy-md-0 mb-4">
          <div className="col-md-4">
            {deal.video_url && <iframe src={deal.video_url} className="thumbnail rounded"></iframe>}
            {!deal.video_url && <img src={src} alt={deal.title} className="thumbnail rounded" />}
          </div>
          <div className="col-md-8">
            <div className="d-flex flex-column gap-4">
              <h1 className="fw-bold m-0">{deal.title}</h1>

              <div>
                <p className="text-muted fw-bold m-0">Description</p>
                <p className="m-0">{deal.description}</p>
              </div>

              <div>
                <p className="text-muted fw-bold m-0">Items</p>
                <div className="d-flex flex-column gap-2">
                  {deal.products.map((product, index) => {
                    let productSrc = "/upload-white.png"
                    if (product.thumbnail) productSrc = product.thumbnail
                    // if (product.thumbnail_url) productSrc = product.thumbnail_url.replace("public", url)

                    return (
                      <div key={product.id} className="d-flex gap-2 align-items-center">
                        {!product.video_url && <img src={productSrc} alt={product.title} className="img-thumbnail rounded" width={40} height={40} />}
                        <div>
                          <p className="m-0">{product.title}</p>
                          <p className="text-muted small m-0">Qty: {product.order_quantity}</p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <p className="fs-5 text-muted fw-bold text-decoration-line-through">Rs. {deal.price.toFixed(2)}</p>
                <p className="fs-3 bg-theme-light px-2 rounded text-theme fw-bold">Rs. {(deal.price - deal.discount).toFixed(2)}</p>
              </div>

              {
                !cartState.productsById[deal.slug]
                  ? <button className="btn btn-lg btn-theme w-25" onClick={handleCart}>Add to Cart</button>
                  : <div className="d-flex gap-3 justify-content-between align-items-center w-25">
                    <button type="button" className="btn btn-lg btn-light-theme flex-grow-1" onClick={handleDecrement}><i className="bi bi-dash-lg"></i></button>
                    <p className="flex-grow-1 fs-5 text-muted text-center fw-bold m-0">{cartState.productsById[deal.slug]}</p>
                    <button type="button" className="btn btn-lg btn-light-theme flex-grow-1" onClick={handleIncrement}><i className="bi bi-plus-lg"></i></button>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    </GuestLayout>
  )
}

export default Deal
